<template>
	<v-card class="user-form">
		<v-card-text class="pa-8 py-10">
			<v-form ref="form">
				<v-row no-gutters>
					<v-col cols="12" sm="4">
						<v-text-field
							v-model="user.name"
							:label="$gettext('Name')"
							filled
							class="px-2"
							:rules="[rules.required]"
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="4">
						<v-text-field
							v-model="user.email"
							:label="$gettext('Email')"
							filled
							class="px-2"
							:rules="[rules.required, rules.email]"
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="4">
						<v-select
							v-model="user.role"
							:items="roles"
							:label="$gettext('Role')"
							item-text="name"
							item-value="id"
							filled
							class="px-2"
							:rules="[rules.required]"
						></v-select>
					</v-col>
					<template v-if="!edit">
						<v-col cols="12" sm="4">
							<v-text-field
								type="password"
								:label="$gettext('Password')"
								v-model="user.password"
								required
								:rules="[passwordRules.required, passwordRules.characteres]"
								filled
								class="px-2"
							/>
						</v-col>
						<v-col cols="12" sm="4">
							<v-text-field
								type="password"
								:label="$gettext('Repeat Password')"
								v-model="user.again"
								required
								:rules="[passwordRules.required, passwordRules.characteres, passwordMatch]"
								filled
								class="px-2"
							/>
						</v-col>
						<v-col cols="12" sm="4">
							<v-select
								v-model="user.establishments"
								:items="establishments"
								:label="$gettext('Establishments')"
								item-text="name"
								item-value="id"
								filled
								multiple
								return-object
								class="px-2"
								:rules="[rules.requiredList]"
							></v-select>
						</v-col>
					</template>
					<template v-else>
						<v-col cols="12">
							<v-row no-gutters>
								<v-col cols="12" sm="4" offset-md="8">
									<v-select
										v-model="user.establishments"
										:items="establishments"
										:label="$gettext('Establishments')"
										item-text="name"
										item-value="id"
										filled
										multiple
										return-object
										class="px-2"
										:rules="[rules.requiredList]"
									></v-select>
								</v-col>
							</v-row>
						</v-col>
					</template>
					<v-col cols="12" sm="4" class="px-5">
						<v-row no-gutters align="center" justify="center">
						<v-color-picker hide-inputs v-model="user.color"></v-color-picker>
						</v-row>
					</v-col>
					<v-col v-if="showTerapeutOptions" cols="12" sm="4">
						<v-select
							v-model="user.specialities"
							:items="specialities"
							:label="$gettext('Specialities')"
							item-text="name"
							item-value="id"
							filled
							multiple
							return-object
							class="px-2"
						></v-select>
						<template v-if="showTerapeutOnlyOptions">
						<p class="primary--text">Permissões Extra</p>
						<v-checkbox
								v-model="user.patients_permission"
								class="mt-0 pt-0"
								color="primary"
								dense
								label="Adicionar e ver lista de pacientes"
						>
						</v-checkbox>
						<v-checkbox
								v-model="user.calendar_permission"
								class="mt-0 pt-0"
								color="primary"
								dense
								label="Acesso total ao calendário"
						>
						</v-checkbox>
						<v-checkbox
								v-model="user.appointment_permission"
								class="mt-0 pt-0"
								color="primary"
								dense
								label="Criar consultas"
						>
						</v-checkbox>
						</template>
					</v-col>
					<v-col v-if="showTerapeutOptions" cols="12" sm="4">
						<v-text-field
							v-model="user.license_number"
							:label="$gettext('Professional License Number')"
							filled
							class="px-2"
						></v-text-field>
						<v-select
							v-model="user.modules"
							:items="modules"
							:label="$gettext('Modules')"
							item-text="name"
							item-value="id"
							filled
							multiple
							class="px-2"
						></v-select>
					</v-col>
					<v-col cols="12" sm="12" class="px-5 pt-2">
						<v-alert v-model="errorPlan" color="red" icon="warning">
							<translate>You reached the maximum number of users under your plan subscription</translate>
						</v-alert>
						<v-alert v-model="showAlert" color="red" icon="warning">{{errorMessage}}</v-alert>
					</v-col>
				</v-row>
			</v-form>
		</v-card-text>
		<v-divider></v-divider>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn v-if="edit" color="primary" text @click="editUser" :loading="loading">
				<translate>Save</translate>
			</v-btn>
			<v-btn v-else color="primary" text @click="createUser" :loading="loading">
				<translate>Create</translate>
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import axios from "axios";

export default {
	name: "UserForm",
	props: {
		user: {
			default: () => ({
				name: "",
				email: "",
				password: "",
				again: "",
				role: "",
				establishments: [],
				specialities: [],
				modules: [],
				color: "",
				license_number: "",
				patients_permission: false,
				calendar_permission: false,
				appointment_permission: false
			})
		},
		specialities: {
			default: []
		},
		edit: {
			default: false
		},
		space: {}
	},
	data: () => ({
		showAlert: false,
		errorMessage: "",
		loading: false,
		errorPlan: false
	}),
	methods: {
		createUser() {
			this.errorMessage = "";
			this.showAlert = false;
			if (this.validate()) {
				this.loading = true;
				const formData = new FormData();
				formData.append("add_user", true);
				formData.append("space_id", this.space.id);
				formData.append("name", this.user.name);
				formData.append("email", this.user.email);
				formData.append("role", this.user.role);
				formData.append("password", this.user.password);
				formData.append("again", this.user.again);
				formData.append("license_number", this.user.license_number);
				formData.append("color", this.user.color);
				formData.append("patients_permission", this.user.patients_permission ? true : false);
				formData.append("calendar_permission", this.user.calendar_permission ? true : false);
				formData.append("appointment_permission", this.user.appointment_permission ? true : false);
				this.user.specialities.forEach(s => {
					formData.append("specialities", s.id);
				});
				this.user.establishments.forEach(e => {
					formData.append("establishments", e.id);
				});
				this.user.modules.forEach(m => {
					formData.append("modules", m);
				});
				axios
					.post("/settings", formData)
					.then(response => {
						if (response.status === 200) {
							if (response.data.result === "created") {
								this.$emit("add-user", response.data.user);
								this.user = {
									name: "",
									email: "",
									password: "",
									again: "",
									role: "",
									specialities: [],
									color: "",
									license_number: ""
								};
							} else if (response.data.result === "error") {
								this.errorMessage =
									response.data.error[Object.keys(response.data.error)[0]][0];
								this.showAlert = true;
							} else if (response.data.result === "limited") {
								this.errorPlan = true;
							}
						}
						this.loading = false;
					})
					.catch(error => {
						console.log(error);
						this.loading = false;
					});
			}
		},
		editUser() {
			this.errorMessage = "";
			this.showAlert = false;
			if (this.validate()) {
				this.loading = true;
				const formData = new FormData();
				formData.append("name", this.user.name);
				formData.append("email", this.user.email);
				formData.append("role", this.user.role);
				formData.append("license_number", this.user.license_number);
				formData.append("color", this.user.color);
				formData.append("patients_permission", this.user.patients_permission ? true : false);
				formData.append("calendar_permission", this.user.calendar_permission ? true : false);
				formData.append("appointment_permission", this.user.appointment_permission ? true : false);
				this.user.specialities.forEach(s => {
					formData.append("specialities", s.id);
				});
				this.user.establishments.forEach(e => {
					formData.append("establishments", e.id);
				});
				this.user.modules.forEach(m => {
					formData.append("modules", m);
				});
				axios
					.post("/user/" + this.user.id + "/edit", formData)
					.then(response => {
						if (response.status === 200) {
							console.log(response.data);
							if (response.data.result === "edited") {
								this.$router.push({
									name: "settings",
									params: {
										tab: "users"
									}
								});
							} else if (response.data.result === "error") {
								this.errorMessage =
									response.data.error[Object.keys(response.data.error)[0]][0];
								this.showAlert = true;
							}
						}
						this.loading = false;
					})
					.catch(error => {
						console.log(error);
						this.loading = false;
					});
			}
		},
		validate() {
			return this.$refs.form.validate();
		}
	},
	computed: {
		modules() {
			let modules = [];
			let spaceModules = this.$store.getters.spaceModules;
			for(let i = 0; i < spaceModules.length; i++) {
				if(spaceModules[i] == 'mtc') modules.push({id: 'mtc', name: this.$gettext("TCM")});
				if(spaceModules[i] == 'fito') modules.push({id: 'fito', name: this.$gettext("Fitotherapy")});
				if(spaceModules[i] == 'osteo') modules.push({id: 'osteo', name: this.$gettext("Osteopathy")});
				//if(spaceModules[i] == 'base') modules.push({id: 'base', name: this.$gettext("Generic")});
			}
			return modules;
		},
		establishments() {
			return this.$store.getters.establishments;
		},
		passwordRules() {
			return {
				required: v => !!v || this.$gettext("Password is required"),
				characteres: v =>
					(v && v.length >= 8) ||
					this.$gettext("Password must have at least 8 characters")
			};
		},
		rules() {
			return {
				requiredList: value => value.length > 0 || this.$gettext("Required."),
				required: value => !!value || this.$gettext("Required."),
				email: value => {
					const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
					return pattern.test(value) || this.$gettext("Invalid e-mail.");
				}
			};
		},
		roles() {
			let adminSpace = this.$store.getters.spaceId == 7;
			if(adminSpace) {
				return [
					{ id: "admin", name: this.$gettext("Admin") }
				];
			} else if(this.isExternalEntity) {
				return [
					{ id: "manager", name: this.$gettext("Manager") }
				];
			} else {
				return [
					{ id: "manager", name: this.$gettext("Manager") },
					{ id: "terapeut", name: this.$gettext("Health Professional") },
					{ id: "receptionist", name: this.$gettext("Receptionist") }
				];
			}
		},
		isExternalEntity() {
			return this.$store.getters.isExternalEntity;
		},
		passwordMatch() {
			return (
				this.user.password === this.user.again ||
				this.$gettext("Passwords must match")
			);
		},
		showTerapeutOptions() {
			if (this.isExternalEntity) return false;
			if (this.user.role === "manager" || this.user.role === "terapeut")
				return true;
			else return false;
		},
		showTerapeutOnlyOptions() {
			if(this.user.role === "terapeut") return true;
			else return false;
		}
	}
};
</script>